import sortBy from 'lodash-es/sortBy'

export function filterByTitleAndNumber(
  { request_no: requestNumber, title },
  search
) {
  return (
    String(requestNumber).toLowerCase().includes(search.toLowerCase()) ||
    title.toLowerCase().includes(search.toLowerCase())
  )
}

export function sortServiceRequestsMoreItems(items) {
  return sortBy(items, ['title'])
}
